import { FC } from 'react';
import { SmsTemplatesViewMode } from '../config';
import { SmsTemplate } from '../smsTemplateListFlowMapper';
import { SmsTemplateCard } from '../SmsTemplateCard';
import { SmsTemplateTable } from '../SmsTemplateTable';

type SmsTemplateListContentProps = {
  viewMode: SmsTemplatesViewMode;
  items: SmsTemplate[];
  onSelectTemplate?: (template: SmsTemplate) => void;
};

export const SmsTemplateListContent: FC<SmsTemplateListContentProps> = ({ viewMode, items, onSelectTemplate }) => {
  if (viewMode === 'table') {
    return <SmsTemplateTable items={items} onSelectTemplate={onSelectTemplate} />;
  }

  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3'>
      {items.map((template) => (
        <SmsTemplateCard key={template.id} template={template} onSelect={onSelectTemplate} />
      ))}
    </div>
  );
};
